import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/users/me')
        .then(u => setUser(u))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password, totpCode, rememberMe) => {
    const data = { email, password, rememberMe };
    if (totpCode) data.totpCode = totpCode;
    const result = await api.post('/auth/login', data);
    if (result.needs2FA) return result;
    if (result.needs2FASetup) return result;
    localStorage.setItem('token', result.token);
    setUser(result.user);
    return result;
  };

  const logout = () => {
    api.post('/auth/logout', {}).catch(() => {});
    localStorage.removeItem('token');
    setUser(null);
  };

  const updateUser = (updates) => setUser(prev => ({ ...prev, ...updates }));

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-gray-100"><div className="text-gray-500">Cargando...</div></div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
